import { useHttp } from "./useHttp";
import { useDispatch } from "react-redux";
import { createSetPaymentsDataAction } from "../actions/dataActions";

export const usePaymentsData = (params, dataFresh) => {
  const dispatch = useDispatch();
  const [data, loading, error] = useHttp("payments", "get", params, dataFresh);
  if (error) {
    throw Error("There was an error");
  }

  if (!loading && data !== null) {
    dispatch(createSetPaymentsDataAction(data));
  }

  return !loading;
};
